import { render, staticRenderFns } from "./AppVideo.vue?vue&type=template&id=6014984d"
var script = {}
import style0 from "./AppVideo.vue?vue&type=style&index=0&id=6014984d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports